import LayoutsDrafts from './LayoutsDrafts';

export default LayoutsDrafts;
